import React from 'react';
import { TextSelection } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';

import { Popper, PopperProps } from '@lyearn/ui';

import CalloutTypes from './components/CalloutTypes';
import DividerTypes from './components/DividerTypes';
import FlashCardTypes from './components/FlashCardTypes';
import MediaLayouts from './components/MediaLayouts';
import { TooltipMenuBlockType } from './types';
import { getTooltipAnchorEl } from './utils';

interface TooltipMenuProps {
  open: boolean;
  editorView: EditorView;
  type: TooltipMenuBlockType;
}

const popperOptions = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, 12],
      },
    },
    {
      name: 'flip',
      enabled: false,
    },
  ],
};

const TooltipMenuBlockTypeFactory = {
  [TooltipMenuBlockType.Callout]: CalloutTypes,
  [TooltipMenuBlockType.Media]: MediaLayouts,
  [TooltipMenuBlockType.Divder]: DividerTypes,
  [TooltipMenuBlockType.FlashCard]: FlashCardTypes,
};

export const TooltipMenu: React.FC<TooltipMenuProps> = (props) => {
  const { open, editorView: view, type } = props;

  const SettingsComponent = TooltipMenuBlockTypeFactory[type];

  if (!type) {
    return null;
  }

  //TODO: calculate this conditionally not for every re-render
  //Problem: unable to find a condition, view.state.selection's ref is changing on option change resulting in a very bad flicker
  let anchorEl = null;
  if (view && open) {
    const currentPos = view.state.selection.$from.pos;
    const domAtPos =
      view.state.selection instanceof TextSelection
        ? view.domAtPos(currentPos).node.parentElement
        : view.nodeDOM(currentPos);
    if (domAtPos) {
      anchorEl = getTooltipAnchorEl(domAtPos) as PopperProps['anchorEl'];
    }
  }

  if (!anchorEl) {
    return null;
  }

  return (
    <Popper
      anchorEl={anchorEl}
      className="rounded-8 border border-border bg-bg-primary shadow-02"
      open={open}
      placement="top"
      popperOptions={popperOptions}>
      <SettingsComponent view={view} />
    </Popper>
  );
};
